import React, { Component } from 'react';
import MarketingSection from "../marketingSection";
import { withLocalize } from "react-localize-redux";
import { getLanguage} from '../../../store/apiWrapper';
import PopupMultiSelectButton from "../../common/popupMultiSelectButton";
import { connect as connectFormik } from "formik";
import { connect } from "react-redux";
import { domainActions } from "../../../store/domainStore";
import { unicornAttributes, unicornCountry } from "../../../store/marketingListStore";
import { bindActionCreators } from 'redux';
import BbInput from '../../styling/bbInput';
import { Translate } from "react-localize-redux";

class RegisteredCapital extends Component {
    render() {
        return (
            <MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} searchTip={this.props.translate("SearchTips.Unicorn.Config.RegisteredCapital.Body")}>
            <div className='field bb-field'>
                <div className='columns'>
                    <div className='column is-one-third bb-input-label-column'>
                        <div className="label-wrapper">
                            <span className="marketing-label"> 
                            
                            {unicornCountry() === 'sk' ? <Translate id='MarketingList.RegisteredCapital.EUR' /> : <Translate id='Search.Common.RegisteredCapital' />} </span>
                        </div>
                    </div>
                    <div className="is-flex w-100">
                        <div className='column is-one-half bb-input-column'>
                            <BbInput label={this.props.translate("Common.From")} name="registeredCapital.countFrom" type="number" placeholder={{ type: 'inline' }} style={{ paddingLeft: "0", paddingRight: "0" }} />
                        </div>
                        <div className='column is-one-half bb-input-column'>
                            <BbInput label={this.props.translate("Common.To")} name="registeredCapital.countTo" type="number" placeholder={{ type: 'inline' }} style={{ paddingLeft: "0", paddingRight: "0" }} />
                        </div>
                    </div>
                </div>
            </div>
            </MarketingSection>
        )
    }
}
export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(connectFormik(RegisteredCapital)));
